module.exports = __webpack_public_path__ + "img/carshina21_09.0485d63e.jpg";